/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { fetchPlatforms, fetchPlatform } from './action';

export const platformsSlice = createSlice({
  name: 'platform',
  initialState: {
    platforms: [],
    platform: null,
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlatforms.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPlatforms.fulfilled, (state, action) => {
        state.platforms = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchPlatforms.rejected, (state, action) => {
        state.error = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchPlatform.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPlatform.fulfilled, (state, action) => {
        state.platform = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchPlatform.rejected, (state, action) => {
        state.error = action.payload;
        state.isLoading = false;
      });
  },
});

export default platformsSlice.reducer;
